import React from 'react';
import { useCallback } from 'react';
import Inc from './Include';
import './Four.scss';

function Four ({notice,click}){
    const useUsers = useCallback( (max,nt) => {
        let lines = [];
        for( let i=1 ; i<=max ; i++ ){
            const key = "user" + i;
            let classUser = "fas fa-"+Inc.FACE_ICON[i-1];
            let classComment = "fas fa-exclamation mini";
            if( i===nt ){
                classUser += " notice";
                classComment += " show";
            } else {
                classComment += " hide";
            }
            lines[i] = (
                <td key={key}>
                    <i className={classComment}></i><br/>
                    <i className={classUser} onClick={()=>click(i)}></i>
                </td>
            )
        }
        return lines;
    },[notice]);
    const users = useUsers(4,notice);

    return (
		<div id="four">
            <table><tbody><tr>
            {users}
            </tr></tbody></table>
            <p>
                JUNE BEATS YELLOW<br/>
                ver.190501<br/><br/>
                <a href="https://goisagi.retro-ink.com/" rel="noopener noreferrer">retro-ink</a>
            </p>
        </div>
	);
}

export default Four;
